const BASE_URL = process.env.REACT_APP_API_BASE_URL;

async function authFetch(path, options = {}) {
  const token = await localStorage.getItem("token");
  const request = new Request(`${BASE_URL}${path}`, {
    ...options,
    headers: new Headers({
      "Content-Type": "application/json",
      Authorization: token,
      ...(options.headers || {}),
    }),
  });
  const res = await fetch(request);
  if (!res.ok) {
    const body = await res.text();
    throw new Error(body || res.statusText);
  }
  return res.json();
}

const EmployeeCode = {
  updateTimesheet: (payload) =>
    authFetch("/timesheet/support/update_employee_code", {
      method: "PATCH",
      body: JSON.stringify(payload),
    }),

  updateCatalog: (payload) =>
    authFetch("/catalog/employee", {
      method: "PATCH",
      body: JSON.stringify(payload),
    }),
  
  updateIdentity: (payload) =>
    authFetch("/support/company-user/employee-code", {
      method: "PUT",
      body: JSON.stringify(payload),
    }),
};

export default EmployeeCode;
